import { images } from "../constants";
import {
  PointSectionDisclaimer,
  PointSectionHeadingAccentChar,
  PointSectionFlowFrame,
  PointSectionFlowSystemImage,
  PointSectionHeading,
  PointSectionHeadingAccent,
  PointSectionPointAccent,
  PointSectionPointAccentBlue,
  PointSectionPointCard,
  PointSectionPointHeader,
  PointSectionPointIcon,
  PointSectionPointList,
  PointSectionPointNumber,
  PointSectionPointText,
  PointSectionRoot,
} from "../styles";

const pointCards = [
  {
    number: "01",
    icon: images.pointBribery,
    base: "投資ワンルーム専門の複数社が",
    accentBlue: "「最高値」",
    accent: "を競い合います。",
  },
  {
    number: "02",
    icon: images.pointListener,
    base: "業者との複雑な交渉や調整は",
    accentBlue: "すべてコンシェルジュ",
    accent: "が\nサポートします。",
  },
  {
    number: "03",
    icon: images.pointExpense,
    base: "仲介手数料は",
    accent: "",
    accentBlue: "かかりません。",
  },
  {
    number: "04",
    icon: images.pointCall,
    base: "不動産会社からの営業電話は",
    accent: "",
    accentBlue: "一切ありません。",
  },
];

export default function PointSection() {
  const accentText = "最高価格";

  return (
    <PointSectionRoot>
      <PointSectionHeading>
        スマウルで複数社に
        <br />
        アプローチ。
        <br />
        <PointSectionHeadingAccent>
          {accentText.split("").map((char, index) => (
            <PointSectionHeadingAccentChar key={`${char}-${index}`}>{char}</PointSectionHeadingAccentChar>
          ))}
        </PointSectionHeadingAccent>
        で売却が可能
      </PointSectionHeading>

      <PointSectionFlowFrame>
        <PointSectionFlowSystemImage src={images.pointSystem} alt="査定フロー図" />
      </PointSectionFlowFrame>

      <PointSectionPointHeader $backgroundImage={images.ribbonWhite}>
        スマウルのスマート売却のポイント
      </PointSectionPointHeader>

      <PointSectionPointList>
        {pointCards.map((item) => (
          <PointSectionPointCard key={item.number}>
            <PointSectionPointIcon src={item.icon} alt="" aria-hidden="true" />
            <PointSectionPointText>
              {item.base}
              <br />
              <PointSectionPointAccentBlue>{item.accentBlue}</PointSectionPointAccentBlue>
              <PointSectionPointAccent>{item.accent}</PointSectionPointAccent>
            </PointSectionPointText>
            <PointSectionPointNumber>{item.number}</PointSectionPointNumber>
          </PointSectionPointCard>
        ))}
      </PointSectionPointList>

      <PointSectionDisclaimer>
        ※弊社コンシェルジュが査定に必要な情報をまとめるため、一度だけお電話させていただきます。
      </PointSectionDisclaimer>
    </PointSectionRoot>
  );
}
